module.exports = __webpack_public_path__ + "static/gordon-ramsay-551b332bb1f82cd3d41e2f4a72b7b91b.jpg";